import { supabase } from "../../../supabase";

// Never use this outside Router.
// Use useWorkspaceData hook instead when necessary.
const fetchAuthSession = async () => {
  const { data, error } = await supabase.auth.getSession();

  if (error) {
    console.error(error);
  }

  return {
    userId: data?.session?.user?.id,
    isAuthenticated: !!data?.session?.user?.id,
  };
};

export { fetchAuthSession };
